<template>
  <ElForm inline class="transactions-search" @submit.native.prevent="search">
    <ElFormItem>
      <ElInput
        v-model="subscription_token"
        name="subscription_token"
        :placeholder="$t('APP.TRANSACTIONS.PURCHASES_SUBSCRIPTION_TOKEN')"
      />
    </ElFormItem>
    <ElFormItem>
      <ElInput
        v-model="renewal_token"
        name="renewal_token"
        :placeholder="$t('APP.TRANSACTIONS.PURCHASES_RENEWAL_TOKEN')"
      />
    </ElFormItem>
    <ElFormItem>
      <ElButton type="primary" native-type="submit">
        {{ $t('APP.TRANSACTIONS.FILTER_RESULT') }}
      </ElButton>
    </ElFormItem>
    <ErrorsList v-if="errors" :errors="errors" />
  </ElForm>
</template>

<script>
import ErrorsList from '@@/common/ErrorsList';
export default {
  name: 'TransactionsSubPurchasesSearch',

  components: {
    ErrorsList,
  },

  props: {
    errors: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      subscription_token: '',
      renewal_token: '',
    };
  },

  methods: {
    search() {
      this.$emit('search', {
        subscription_token: this.subscription_token,
        renewal_token: this.renewal_token,
      });
    },
  },
};
</script>

<style lang="scss">
.transactions-search {
  .el-form-item {
    margin-top: $global-margin / 2;
    margin-bottom: $global-margin / 2;
  }

  .errors-box {
    margin: 0 10px;
  }

  input {
    font-family: $lb-body-en-font-family;
  }
}
</style>
